import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/**
 * HelpTooltip - Contextual help icon with tooltip and link to full documentation
 *
 * @param {string} tip - Short tooltip text shown on hover
 * @param {string} docId - Document ID to link to (e.g., "rules-overview")
 * @param {string} className - Additional CSS classes for the icon container
 *
 * @example
 * <HelpTooltip tip="Rules automate notifications" docId="rules-overview" />
 */
export function HelpTooltip({ tip, docId, className = '' }) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <Link
            to={`/help/${docId}`}
            className={`inline-flex items-center cursor-help ${className}`}
            onClick={(e) => e.stopPropagation()}
          >
            <HelpCircle
              className="w-4 h-4 text-slate-400 hover:text-slate-600 transition-colors"
              aria-label={`Help: ${tip}`}
            />
          </Link>
        </TooltipTrigger>
        <TooltipContent
          className="max-w-xs"
          side="top"
        >
          <p className="text-sm">{tip}</p>
          <p className="text-xs text-slate-400 mt-1">Click for full guide</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default HelpTooltip;
